import { useEffect, useRef } from 'react'

import { useLeftSidebar } from '@/modules/cms/views/post/components/builder/context'

import Sidebar from '../Sidebar'

import Assets from './Assets'
import Blocks from './Blocks'
import Layers from './Layers'
import Pages from './Pages'

export default function LeftSidebar({ defaultValue, pages = <PagesSidebar />, layers = <LayersSidebar />, assets = <AssetsSidebar />, blocks = <BlocksSidebar /> }) {
  const { setValue } = useLeftSidebar()

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue, setValue])

  return <>
    {pages}
    {layers}
    {assets}
    {blocks}
  </>
}

function SidebarWrapper({ children, name, ...props }) {
  const { value } = useLeftSidebar()

  return <Sidebar open={value === name} {...props}>
    {children}
  </Sidebar>
}

const PagesSidebar = () => <SidebarWrapper name='page'><Pages /></SidebarWrapper>
const LayersSidebar = () => <SidebarWrapper name='layers' size='72'><Layers /></SidebarWrapper>
const AssetsSidebar = () => {
  const ref = useRef()
  const { value } = useLeftSidebar()

  return <div className={`flex flex-row ${value === 'assets' ? 'block' : 'hidden'}`}>
    <SidebarWrapper name='assets'>
      <Assets floatbarRef={ref} />
    </SidebarWrapper>
    <div className='relative' ref={ref}></div>
  </div>
}
const BlocksSidebar = () => <SidebarWrapper name='blocks'><Blocks /></SidebarWrapper>
